import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { PerformanceSchema, type Performance } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

export function usePerformance(
  range: TimeRange,
  options: UseMetricOptions = {},
) {
  return useQuery<Performance>({
    queryKey: qk.metrics.performance(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/performance?${toSearchParams(range).toString()}`,
        { signal },
      );
      return PerformanceSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
